import { render, staticRenderFns } from "./WooContents.vue?vue&type=template&id=0f7dcf5c&"
import script from "./WooContents.vue?vue&type=script&lang=js&"
export * from "./WooContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports